/**
 * PlotBuilderPanel — docking layout wrapper for PlotBuilder.
 */

import { useCallback } from "react";
import { Box } from "@radix-ui/themes";
import { PlotBuilder } from "../plot-builder/PlotBuilder";
import type { PlotBuilderConfig } from "../plot-builder/types";
import type { PlotScope } from "../../api/plots";
import { useProvenanceContext } from "../../context/ProvenanceContext";

interface Props {
  projectId: string;
  onSave?: (config: PlotBuilderConfig, data: Record<string, unknown>[], thumbnail?: string, scope?: PlotScope) => Promise<void>;
  initialConfig?: PlotBuilderConfig;
}

export default function PlotBuilderPanel({ projectId, onSave, initialConfig }: Props) {
  const { selectArtifact, selectedArtifactId } = useProvenanceContext();
  const handlePointClick = useCallback(
    (row: Record<string, unknown>) => {
      const nodeId = row._node_id as string | undefined;
      if (nodeId) selectArtifact(nodeId);
    },
    [selectArtifact],
  );

  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <PlotBuilder projectId={projectId} onSave={onSave} initialConfig={initialConfig} onPointClick={handlePointClick} selectedNodeId={selectedArtifactId} />
    </Box>
  );
}
